export default "__VITE_ASSET__czeorLAm__"